<template>
  <div>
    <!--
      <TrialProgressBar :step="stepNumber"></TrialProgressBar>
    <BookingStep v-if="currentStep === 'test-new'"></BookingStep>
    <ConfirmContact v-if="currentStep === 'test-booked'"></ConfirmContact>
    <TechCheckPassed v-if="currentStep === 'confirmed'"></TechCheckPassed>
    <TechPassed v-if="currentStep === 'test-passed'"></TechPassed>
    -->
    <AlfaWidget></AlfaWidget>
    <OnBoarding></OnBoarding>
  </div>
</template>

<script>
  import CalendarSchedule from './bookingstep/CalendarSchedule'
  import DaySchedule from './bookingstep/DaySchedule'
  import { todayHowString } from '@/utils/utils';
  import store from '@/store';
  import { dateConvert, MONTH_NAMES } from '../../../../utils/utils';
  import TrialProgressBar from './TrialProgressBar';
  import BookingStep from  './bookingstep/BookingStep';
  import TehBookingStep from './tehbookingstep/TehBookingStep';
  import WaitingTehBookingStep from './waitingtehbooking/WaitingTehBookingStep'
  import TechCheckPassed from './techcheckpassed/TechCheckPassed';
  import { mapGetters, mapActions } from 'vuex';
  import TechPassed from './techpassed/TechPassed';
  import ConfirmContact from './confirmcontact/ConfirmContact';
  import OnBoarding from './OnBoarding/OnBoarding.vue';
  import AlfaWidget from './AlfaWidget.vue';

  export default {
    name: 'TrialLesson',
    components: {
      CalendarSchedule,
      DaySchedule,
      TrialProgressBar,
      BookingStep,
      TehBookingStep,
      WaitingTehBookingStep,
      TechCheckPassed,
      TechPassed,
      ConfirmContact,
      OnBoarding,
      AlfaWidget
    },
    data: function () {
      return {
        // lessonStatus: 0,
        selectedDate: todayHowString(),
      }
    },
    computed: {
      ...mapGetters({
        currentStep: 'trialBookingFlow/currentStep',
      }),
      stepNumber(){
        if(this.currentStep === 'test-new'){
          return 1;
        }
        if(this.currentStep === 'test-booked'){
          return 2;
        }
        if(this.currentStep === 'confirmed'){
          return 3;
        }
        if(this.currentStep === 'test-passed'){
          return 5;
        }
        return 0;
      },
      selectedDateConvert() {
        return dateConvert(this.selectedDate)
      },
      selectedHourStart() {
        if (this.selectedHour == null) {
          return '';
        }
        return this.selectedHour.start;
      },
    },
    mounted(){
      store.dispatch('trialBookingFlow/getHomeInfo');
    },
    methods: {
    }
  }
</script>

<style lang="scss" scoped>

  .reserve_lesson_container {
      padding: 2.3rem 3.3rem;
      display: flex;
      flex-wrap: wrap;
      flex-direction: column;
  }

  .reserve_lesson_body{
      display: flex;
      min-height: 35rem;
      margin-top:15px;
  }

  .calendar_wrapper {
    margin-right: 6rem;
  }

  .calendar_text, .day_schedule_text {
    font-family: FuturaPT;
    font-size: 16px;
    line-height: 20px;
    letter-spacing: 0.5px;
    color: rgba(11, 16, 34, 0.3);
    margin-bottom: 2.5rem;
    display: inline-block;
  }

  .reserve_lesson_footer {
    width: 100%;
    display: flex;
    margin-top: 17px;
    margin-bottom: 12px;

    .button {
      margin-left: auto;
      padding: 0.75rem 2.5rem 1rem 2.5rem;
    }
  }

  .component-fade-enter-active, .component-fade-leave-active {
    transition: opacity .2s ease;
  }

  .component-fade-enter, .component-fade-leave-to
    /* .component-fade-leave-active below version 2.1.8 */
  {
    opacity: 0;
  }
</style>
